import { ItemType } from "@/types";

export const SORT_BY = {
  products_total: "products_total",
  shares_total: "shares_total",
  shared_products_total: "shared_products_total",
  products_added: "products_added",
  products_removed: "products_removed",
  delivery_date: "delivery_date",
  count: "count",
  users_total: "users_total",
  start_week: "start_week",
  delta: "delta",
  product_type: "product_type",
} as const;

export const SORT_DIR = {
  asc: "asc",
  desc: "desc",
  base: "base",
} as const;

export const REQUEST_PARAMS = {
  date_from: "date_from",
  date_to: "date_to",
  size: "size",
  sort_by: "sort_by",
  sort_dir: "sort_dir",
  user_id: "user_id",
  product_id: "product_id",
} as const;

export const CONTENT_KEYS = {
  chart: "chart",
  table: "table",
  pieChart: "pieChart",
  itemsTable: "itemsTable",
} as const;

export const ITEMS_KEYS = [
  "defaultShareItems",
  "itemsAdded",
  "itemsRemoved",
  "deliveredItems",
  "shares",
] as const;

export const PREFS_KEYS = ["itemsAdded", "itemsRemoved"] as const;

export const ACTIONS_KEYS = {
  reset: "reset",
  datePicker: "date-picker",
  dateSelect: "date-select",
  limit: "limit",
};

export const DONT_SHOW_KEYS = ["productId", "shareId"] as (keyof ItemType)[];

export const DELTA_STYLES = {
  totallyAdded: "text-success last:after:ml-1 last:after:content-['↑']",
  totallyRemoved: "text-destructive last:after:ml-1 last:after:content-['↓']",
  partiallyRemoved: "text-destructive last:after:ml-1 last:after:content-['↓']",
  partiallyAdded: "text-success last:after:ml-1 last:after:content-['↑']",
  noChanges: "text-muted-foreground",
};
